import api from 'Application/api/api';

const getPendingMeasureTasksByEmployee = (id, cancelToken = null) =>
    api.get(`/measures/tasks/pending/by-employee/${id}`, { cancelToken });

export default getPendingMeasureTasksByEmployee;
